import apiClient from "./ApiClient";

/**
 * Get restaurant by ID
 * @param {number|string} id
 * @param {string} language
 * @returns {Promise<Object>} restaurant data
 */
export function getRestaurantById(id, language = "en") {
  return apiClient.get(`/restaurants/${id}`, {
    headers: { "Accept-Language": language },
  }).then((res) => res.data);
}

/**
 * Get restaurant by owner ID
 * @param {number|string} ownerId
 * @param {string} language
 * @returns {Promise<Object>} restaurant data
 */
export function getRestaurantByOwnerId(ownerId, language = "en") {
  return apiClient.get(`/restaurants/owner?ownerId=${ownerId}`, {
    headers: { "Accept-Language": language },
  }).then((res) => res.data);
}

/**
 * Update an existing restaurant
 * @param {number|string} id
 * @param {Object} payload
 * @param {string} language
 * @returns {Promise<Object>} updated restaurant
 */
export function updateRestaurant(id, payload, language = "en") {
  return apiClient.put(`/restaurants/${id}`, payload, {
    headers: { "Accept-Language": language },
  }).then((res) => res.data);
}

/**
 * Update restaurant working days
 * @param {number|string} id
 * @param {Array<string>} workingDays
 * @param {string} language
 * @returns {Promise<Object>} updated restaurant
 */
export function updateWorkingDays(id, workingDays, language = "en") {
  const params = new URLSearchParams();
  workingDays.forEach(day => params.append('workingDays', day));
  
  return apiClient.post(`/restaurants/update/working-days/${id}?${params.toString()}`, null, {
    headers: { "Accept-Language": language },
  }).then((res) => res.data);
}

/**
 * Get delivery slots for a restaurant
 * @param {number|string} restaurantId
 * @returns {Promise<Array>} delivery slots
 */
export function getRestaurantDeliverySlots(restaurantId) {
  return apiClient.get(`/restaurants/delivery-slots/${restaurantId}`)
    .then((res) => res.data);
}

/**
 * Get all available delivery slots
 * @returns {Promise<Array>} all delivery slots
 */
export function getAllDeliverySlots() {
  return apiClient.get('/delivery-slots')
    .then((res) => res.data);
}

/**
 * Create a new delivery slot
 * @param {Object} deliverySlot
 * @returns {Promise<Object>} created delivery slot
 */
export function createDeliverySlot(deliverySlot) {
  return apiClient.post('/delivery-slots', deliverySlot)
    .then((res) => res.data);
}

/**
 * Delete a delivery slot
 * @param {number|string} id
 * @returns {Promise<void>}
 */
export function deleteDeliverySlot(id) {
  return apiClient.delete(`/delivery-slots/${id}`);
}
